export enum PkgCategoriesFormFieldsType {
  PKG_DEST_CAT = "pkg_destination_category",
  PACKAGE_TYPE = "package_type",
}

export type CategoryTranslationFormInputs = {
  category_title: string;
  description: string;
};

export interface PackageTranslationFormInput {
  package_title: string;
  imp_info: string;
  itinary: string;
  overview: string;
  package_summary: string;
}
